const groupPrefix = createApiRoute(ApiModule.SUPPLIER, ApiAuthorization.EMPLOYEE)

export const apiSuppliersMatchProducts = {
	fetchSupplierMatchProduct: async (priceListId: number): Promise<IApiResponseModel<IMatchProductModel[]>> => {
		const response = await apiCommon<IMatchProduct[]>(`${groupPrefix}/${priceListId}/match-product`, {
			method: 'GET',
		})
		return { data: response.data.map(d => MatchProduct(d)), meta: response.meta }
	},

	fetchSupplierRawMaterials: async (search?: string): Promise<IApiResponseModel<IRawMaterialModel[]>> => {
		const { data, meta } = await apiCommon<IRawMaterial[]>(`${groupPrefix}/raw-materials`, {
			method: 'GET',
			...createQuery(undefined, undefined, undefined, { search }),
		})
		return { data: data.map(d => RawMaterial(d)), meta }
	},

	saveSupplierMatchProduct: async (priceListId: number, products: IRawMaterialSend[]) => {
		await apiCommon(`${groupPrefix}/${priceListId}/match-product`, {
			method: 'POST',
			body: products,
		})
	},
}
